import { render, staticRenderFns } from "./ButtonCopy.vue?vue&type=template&id=6b68666a&"
import script from "./ButtonCopy.vue?vue&type=script&lang=js&"
export * from "./ButtonCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports